import { EmissionGroup } from "../../models/EmissionGroup";
import AddBusinessTravel from "../../pages/emission/_components/popup-add-emission/step2/emission-group/AddBusinessTravel";
import AddCapitalGoods from "../../pages/emission/_components/popup-add-emission/step2/emission-group/AddCapitalGoods";
import AddEmployeeCommuting from "../../pages/emission/_components/popup-add-emission/step2/emission-group/AddEmployeeCommuting";
import AddEnergy from "../../pages/emission/_components/popup-add-emission/step2/emission-group/AddEnergy";
import AddFertilizer from "../../pages/emission/_components/popup-add-emission/step2/emission-group/AddFertilizer";
import AddFireExtinguishing from "../../pages/emission/_components/popup-add-emission/step2/emission-group/AddFireExtinguishing";
import AddFuel from "../../pages/emission/_components/popup-add-emission/step2/emission-group/AddFuel";
import AddOtherFugitive from "../../pages/emission/_components/popup-add-emission/step2/emission-group/AddOtherFugitive";
import AddOutsourcingTransport from "../../pages/emission/_components/popup-add-emission/step2/emission-group/AddOutsourcingTransport";
import AddOutsourcingWasteDisposal from "../../pages/emission/_components/popup-add-emission/step2/emission-group/AddOutsourcingWasteDisposal";
import AddPurchases from "../../pages/emission/_components/popup-add-emission/step2/emission-group/AddPurchases";
import AddRefrigerants from "../../pages/emission/_components/popup-add-emission/step2/emission-group/AddRefrigerants";
import AddSepticTank from "../../pages/emission/_components/popup-add-emission/step2/emission-group/AddSepticTank";
import AddWastewater from "../../pages/emission/_components/popup-add-emission/step2/emission-group/AddWastewater";
import AddWater from "../../pages/emission/_components/popup-add-emission/step2/emission-group/AddWater";

export const DROPDOWN_EMISSION_GROUP: EmissionGroup[] = [
  {
    _id: "fuel",
    emissionGroup: "Fuel",
    groupTh: "Fuel",
    groupEn: "Fuel",
    description: "Fuel-Description",
    attributeName: "Fuel",
    component: <AddFuel />,
  },
  {
    _id: "energy",
    emissionGroup: "Energy",
    groupTh: "Energy",
    groupEn: "Energy",
    description: "Energy-Description",
    attributeName: "Energy-Source",
    component: <AddEnergy />,
  },
  {
    _id: "wastewater",
    emissionGroup: "Wastewater",
    groupTh: "Wastewater",
    groupEn: "Wastewater",
    description: "Wastewater-Description",
    attributeName: "Wastewater",
    component: <AddWastewater />,
    canQuickUpdateAmount: false,
  },
  {
    _id: "refrigerants",
    emissionGroup: "Refrigerants",
    groupTh: "Refrigerants",
    groupEn: "Refrigerants",
    description: "Refrigerants-Description",
    attributeName: "Refrigerants",
    component: <AddRefrigerants />,
  },
  {
    _id: "waste-disposal",
    emissionGroup: "Waste Disposal",
    groupTh: "Waste-Disposal",
    groupEn: "Waste-Disposal",
    description: "Waste-Disposal",
    attributeName: "Waste-Disposal",
    component: <AddOutsourcingWasteDisposal />,
  },
  {
    _id: "septic-tank",
    emissionGroup: "Septic Tank",
    groupTh: "Septic-Tank",
    groupEn: "Septic-Tank",
    description: "Septic-Tank-Description",
    attributeName: "Septic-Tank",
    component: <AddSepticTank />,
    canQuickUpdateAmount: false,
  },
  {
    _id: "fertilizer",
    emissionGroup: "Fertilizer",
    groupTh: "Fertilizer",
    groupEn: "Fertilizer",
    description: "Fertilize",
    attributeName: "Fertilize",
    component: <AddFertilizer />,
    disabled: false,
  },
  {
    _id: "business-travel",
    emissionGroup: "Business Travel",
    groupTh: "Business-Travel",
    groupEn: "Business-Travel",
    description: "Business-Travel-Description",
    attributeName: "Business-Travel",
    component: <AddBusinessTravel />,
    canQuickUpdateAmount: false,
  },
  {
    _id: "employee-commuting",
    emissionGroup: "Employee Commuting",
    groupTh: "Employee-Commuting",
    groupEn: "Employee-Commuting",
    description: "Employee-Commuting-Description",
    attributeName: "Employee-Commuting",
    component: <AddEmployeeCommuting />,
    canQuickUpdateAmount: false,
  },
  {
    _id: "fire-extinguishing",
    emissionGroup: "Fire Extinguishing",
    groupTh: "Fire-Extinguishing",
    groupEn: "Fire-Extinguishing",
    description: "Fire-Extinguisher",
    attributeName: "Fire-Extinguishing",
    component: <AddFireExtinguishing />,
  },
  {
    _id: "other-fugitive-emissions",
    emissionGroup: "Other Fugitive Emissions",
    groupTh: "Other-Fugitive-Emission",
    groupEn: "Other-Fugitive-Emission",
    description: "Other-Fugitive-Emission",
    attributeName: "Fugitive-Sources",
    component: <AddOtherFugitive />,
  },
  {
    _id: "purchases",
    emissionGroup: "Purchases",
    groupTh: "Purchases",
    groupEn: "Purchases",
    description: "Purchases-Description",
    attributeName: "Purchases",
    component: <AddPurchases />,
  },
  {
    _id: "water",
    emissionGroup: "Water",
    groupTh: "Water",
    groupEn: "Water",
    description: "Purchase-Water",
    attributeName: "Purchase-Water",
    component: <AddWater />,
  },
  {
    _id: "outsourcing-transport",
    emissionGroup: "Outsourcing Transport",
    groupTh: "Outsourcing-Transport",
    groupEn: "Outsourcing-Transport",
    description: "OtherFugitiveEmission-Description",
    attributeName: "Outsourcing-Transport-Source",
    component: <AddOutsourcingTransport />,
    canQuickUpdateAmount: false,
  },
  {
    _id: "capital-goods",
    emissionGroup: "Capital Goods",
    groupTh: "Capital-Goods",
    groupEn: "Capital-Goods",
    description: "Capital-Goods-Description-1",
    attributeName: "Capital-Goods",
    component: <AddCapitalGoods />,
  },
];
